import { ILoginResponse, IUserRegister } from '../../domain/interfaces/auth.interface';
import { RegisterRequestDto } from '../dtos/register.dto';
import { ILoginResponseDto } from '../dtos/login.dto';

/**
 * AuthMapper
 * Responsible for transforming domain models to DTOs and vice versa
 */
export class AuthMapper {
  /**
   * Maps a domain user registration model to the API DTO format
   * @param user Domain user registration model
   * @returns DTO formatted for the API
   */
  static toRegisterDto(user: IUserRegister): RegisterRequestDto {
    return {
      first_name: user.name,
      last_name: user.lastName,
      email: user.email,
      password: user.password,
      terms_accepted: user.termsAccepted,
      terms_url: user.termsUrl || 'https://www.tufirma.digital/terminos-y-condiciones/',
      ...(user.countryCode ? { country_code: user.countryCode } : {}),
    };
  }

  static toLoginResponseDto(dto: ILoginResponseDto): ILoginResponse {
    // Respuesta discriminada 2FA: no hay user/access_token aun.
    if (dto.requires_2fa) {
      return {
        requires2fa: true,
        message: dto.message,
        accessToken: '',
        user: null as unknown as ILoginResponse['user'],
      };
    }

    const user = dto.user!;
    return {
      user: {
        id: user.id,
        email: user.email,
        username: user.username,
        firstName: user.first_name,
        lastName: user.last_name,
        // Normalizar displayName: puede llegar nulo del backend si el usuario no configuró su nombre
        displayName: user.display_name?.trim() || user.username || user.email?.split('@')[0] || '',
        phone: user.phone,
        dni: user.dni,
        jobTitle: user.job_title ?? null,
        professionalRegistrationNumber: user.professional_registration_number ?? null,
        countryCode: user.country_code,
        isActive: user.is_active,
        emailVerified: user.email_verified,
        organization: user.organization
          ? {
              id: user.organization.id,
              name: user.organization.name,
              haveWhiteBrand: user.organization.have_white_brand ?? false,
              haveFacialSign: user.organization.have_facial_sign ?? false,
              haveDocumentWorkflows: user.organization.have_document_workflows === true,
              agencyMode: user.organization.agency_mode === true,
              logoUrl: user.organization.logo_url ?? null,
            }
          : null,
        userRoles: user.user_roles?.map((role) => role.toLowerCase()),
        avatar: user.avatar,
      },
      accessToken: dto.access_token ?? '',
    };
  }
}
